import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import styled from 'styled-components'
import { pageMaxWidthWithPadding, rightSideMaxWidth } from '../styles/page-max-width'
import { ProductDetail1 } from '../components/product-detail-1'
import { ProductDetail2 } from '../components/product-detail-2'
import SvgSetGraphA02 from '../generated/svg/set-graph-a-02'
import SvgSetGraphA01 from '../generated/svg/set-graph-a-01'
import SvgSetGraphA03 from '../generated/svg/set-graph-a-03'
import SvgSetGraphB01 from '../generated/svg/set-graph-b-01'
import SvgSetGraphB02 from '../generated/svg/set-graph-b-02'
import SvgSetGraphB03 from '../generated/svg/set-graph-b-03'
import SvgSetGraphC02 from '../generated/svg/set-graph-c-02'
import SvgSetGraphC01 from '../generated/svg/set-graph-c-01'
import SvgSetGraphA04 from '../generated/svg/set-graph-a-04'
import SvgSetGraphB04 from '../generated/svg/set-graph-b-04'
import SvgSetGraphB05 from '../generated/svg/set-graph-b-05'
import SvgSetGraphD01 from '../generated/svg/set-graph-d-01'
import SvgSetGraphD02 from '../generated/svg/set-graph-d-02'
import SvgSetGraphD03 from '../generated/svg/set-graph-d-03'
import SvgSetGraphD04 from '../generated/svg/set-graph-d-04'
import { SlideNavigator } from '../components/slide-navigator'
import { skuToUrl } from '../utils/sku-to-url'
import { productSku } from '../product-sku'
import { BoxText } from '../components/box-text'

const Outer = styled.div`
  display: grid;
  grid-template-columns: 0 1fr;
  @media (max-width: 40rem){
    display: block;
  }
`

const SectionOuter = styled.div`
  & + & {
    margin-top: 12rem;
    @media (max-width: 40rem){
      margin-top: 6rem;
    }
  }
`

const Inner = styled.div`
  min-width: 0;
`

const Section = styled.div`
  scroll-margin-top: 8rem;
  @media (max-width: 40rem){
    scroll-margin-top: 4rem;
  }
  & + & {
    margin-top: 8rem;
    @media (max-width: 40rem){
      margin-top: 4rem;
    }
  }
`

const Detail1Container = styled.div`
  ${pageMaxWidthWithPadding}
`

const Detail2Container = styled.div`
  margin-top: 4rem;
  @media (max-width: 40rem){
    margin-top: 4rem;
  }
`

const NavigatorOuterWrapper = styled.div``

const NavigatorOuter = styled.div`
  position: sticky;
  top: 8rem;
  width: fit-content;
  scroll-margin-bottom: 8rem;
  @media (max-width: 40rem){
    display: none;
  }
`

const Label = styled.div`
  span {
    display: block;
    font-size: 0.625rem;
    letter-spacing: 0.08em;
    margin-bottom: 0.25rem;
    font-weight: 400;
    line-height: 1.5;
  }
`

const sections = [
  'peelcare',
  'retinoderm',
  'niachinaglow'
]

type SetProductsSectionProps = {

}
export const SetProductsSection: FunctionComponent<SetProductsSectionProps> = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const innerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const inner = innerRef.current
    if(inner){
      const elements = Array.from(inner.children)
      const observer = new IntersectionObserver(entries => {
        const entry = entries.findLast(entry => entry.isIntersecting)
        const index = elements.findIndex(el => el === entry?.target)
        if(index > -1){
          setActiveIndex(index)
        }
      }, {threshold: 0.5})
      elements.forEach(el => observer.observe(el))
      return () => {
        observer.disconnect()
      }
    }
  }, [])
  return <Outer>
    <NavigatorOuterWrapper>
      <NavigatorOuter>
        <SlideNavigator
          activeIndex={activeIndex}
          labels={[
            {
              label: <Label>
                <span>SET 1/3</span>
                PeelCare<br />
                Serum
              </Label>,
              color: '#BBD1BE'
            },
            {
              label: <Label>
                <span>SET 2/3</span>
                RetinoDerm™<br />
                Cream
              </Label>,
              color: '#EFBAB4'
            },
            {
              label: <Label>
                <span>SET 3/3</span>
                NiachinaGlow™<br />
                Gel
              </Label>,
              color: '#D9AFCB'
            },
          ]}
          onChange={index => innerRef.current?.querySelector('#' + (sections[index] ?? ''))?.scrollIntoView({behavior: 'smooth'})}
        />
      </NavigatorOuter>
    </NavigatorOuterWrapper>
    <Inner ref={innerRef}>
      <Section id="peelcare">
        <SetProductsSectionPeelCare10 />
      </Section>
      <Section id="retinoderm">
        <SetProductsSectionRetinoDermo01 />
      </Section>
      <Section id="niachinaglow">
        <SetProductsSectionNiachinaGlow />
      </Section>
    </Inner>
  </Outer>
}

export const TrialSetProductsSection: FunctionComponent<SetProductsSectionProps> = () => {
  const [activeIndex, setActiveIndex] = useState(0)
  const innerRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    const inner = innerRef.current
    if(inner){
      const elements = Array.from(inner.children)
      const observer = new IntersectionObserver(entries => {
        const entry = entries.findLast(entry => entry.isIntersecting)
        const index = elements.findIndex(el => el === entry?.target)
        if(index > -1){
          setActiveIndex(index)
        }
      }, {threshold: 0.5})
      elements.forEach(el => observer.observe(el))
      return () => {
        observer.disconnect()
      }
    }
  }, [])
  return <Outer>
    <NavigatorOuterWrapper>
      <NavigatorOuter>
        <SlideNavigator
          activeIndex={activeIndex}
          labels={[
            {
              label: <Label>
                <span>SET 1/3</span>
                PeelCare<br />
                Serum
              </Label>,
              color: '#BBD1BE'
            },
            {
              label: <Label>
                <span>SET 2/3</span>
                RetinoDerm™<br />
                Cream
              </Label>,
              color: '#EFBAB4'
            },
            {
              label: <Label>
                <span>SET 3/3</span>
                NiachinaGlow™<br />
                Gel
              </Label>,
              color: '#D9AFCB'
            },
          ]}
          onChange={index => innerRef.current?.querySelector('#' + (sections[index] ?? ''))?.scrollIntoView({behavior: 'smooth'})}
        />
      </NavigatorOuter>
    </NavigatorOuterWrapper>
    <Inner ref={innerRef}>
      <Section id="peelcare">
        <SetProductsSectionPeelCare10Pouch />
      </Section>
      <Section id="retinoderm">
        <SetProductsSectionRetinoDermo01Pouch />
      </Section>
      <Section id="niachinaglow">
        <SetProductsSectionNiachinaGlowMini />
      </Section>
    </Inner>
  </Outer>
}

export const SetProductsSectionPeelCare10: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p1-1.png',
        name: 'ピールケアセラム1.0',
        variations: [
          {
            label: '1.0',
            color: '#BBD1BE',
            link: skuToUrl(productSku.peelCare10.single),
            active: true,
          },
          {
            label: '2.0',
            color: '#95B8BB',
            link: skuToUrl(productSku.peelCare20.single),
          },
          {
            label: '3.0',
            color: '#589DAA',
            link: skuToUrl(productSku.peelCare30.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Pセラム１０'
          },
          {
            label: '容量',
            value: '30mL'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY1（スキンサイクルメソッドの1日目）<br />
              1日朝または夜1回（1日1回が上限／目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、グリセリン、ペンチレングリコール、乳酸、ライム果汁、オレンジ果汁、レモン果汁、サンザシエキス、ナツメ果実エキス、グレープフルーツ果実エキス、リンゴ果実エキス、マンデル酸、アラントイン、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、クズ根エキス、アロエベラ葉エキス、クロレラエキス、コンフリー葉エキス、ＰＥＧ－２０ソルビタンココエート、クエン酸、フィトステロールズ、ＢＧ、水添レシチン、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: '角質ケア',
            color: '#B7CEB4'
          },
          {
            label: 'ゴワつきケア',
            color: '#B7CEB4'
          }
        ],
        detail: <>
          角質ケアができる導入美容液。<br />
          グレード1.0は、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方向けの成分を厳選配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #B7CEB4 20%, transparent)',
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'PeelCare Serum Ingredients',
        text2: '肌表面に溜まった角質を柔らかくするアプローチ',
        text3: <>
          クレンジングや洗顔では落とし切れない、溜まった角質を柔らかくするアプローチ。表面のゴワつきをケアします。フルーツケアエキス<sup>※1</sup>配合で、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方におすすめです。
        </>,
        graph: 'p1-1.mp4',
        items: [
          {
            icon: <SvgSetGraphA01 />,
            name: <>
              フルーツケアエキス<sup>※1</sup>
            </>,
            text1: <>
              フルーツ由来の７種類のエキスが肌にしっかり浸透<sup>※2</sup>し、角質を整えます。
            </>
          },
          {
            icon: <SvgSetGraphA02 />,
            name: <>
              乳酸<sup>※3</sup>
            </>,
            text1: <>
              やさしく肌表面の角質をケアし、柔らかな肌へ導きます。同時に肌のキメも整えます。
            </>
          },
          {
            icon: <SvgSetGraphA03 />,
            name: <>
              マンデル酸<sup>※3</sup>
            </>,
            text1: <>
              アーモンド由来の角質ケア成分で、じわじわと角質層へ浸透し、毛穴へアプローチします。
            </>
          },
        ],
        note: '※1 ライム果汁、オレンジ果汁、レモン果汁、サンザシエキス、ナツメ果実エキス、グレープフルーツ果実エキス、リンゴ果実エキス（すべて整肌成分） ※2 角質層まで　※3 整肌成分　※写真はイメージです',
        color: '#B7CEB4'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionPeelCare10Pouch: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'sk2.png',
        name: 'ピールケアセラム1.0',
        variations: [
          {
            label: '1.0',
            color: '#BBD1BE',
            link: skuToUrl(productSku.peelCare10.single),
            active: true,
          },
          {
            label: '2.0',
            color: '#95B8BB',
            link: skuToUrl(productSku.peelCare20.single),
          },
          {
            label: '3.0',
            color: '#589DAA',
            link: skuToUrl(productSku.peelCare30.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'スキンリメド　ピールケアセラム１０　サシェ'
          },
          {
            label: '容量',
            value: '1.5mL'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY1（スキンサイクルメソッドの1日目）<br />
              1日朝または夜1回（1日1回が上限／目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、グリセリン、ペンチレングリコール、乳酸、ライム果汁、オレンジ果汁、レモン果汁、サンザシエキス、ナツメ果実エキス、グレープフルーツ果実エキス、リンゴ果実エキス、マンデル酸、アラントイン、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、クズ根エキス、アロエベラ葉エキス、クロレラエキス、コンフリー葉エキス、ＰＥＧ－２０ソルビタンココエート、クエン酸、フィトステロールズ、ＢＧ、水添レシチン、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: '角質ケア',
            color: '#B7CEB4'
          },
          {
            label: 'ゴワつきケア',
            color: '#B7CEB4'
          }
        ],
        detail: <>
          角質ケアができる導入美容液。<br />
          グレード1.0は、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方向けの成分を厳選配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #B7CEB4 20%, transparent)',
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'PeelCare Serum Ingredients',
        text2: '肌表面に溜まった角質を柔らかくするアプローチ',
        text3: <>
          クレンジングや洗顔では落とし切れない、溜まった角質を柔らかくするアプローチ。表面のゴワつきをケアします。フルーツケアエキス<sup>※1</sup>配合で、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方におすすめです。
        </>,
        graph: 'p1-1.mp4',
        items: [
          {
            icon: <SvgSetGraphA01 />,
            name: <>
              フルーツケアエキス<sup>※1</sup>
            </>,
            text1: <>
              フルーツ由来の７種類のエキスが肌にしっかり浸透<sup>※2</sup>し、角質を整えます。
            </>
          },
          {
            icon: <SvgSetGraphA02 />,
            name: <>
              乳酸<sup>※3</sup>
            </>,
            text1: <>
              やさしく肌表面の角質をケアし、柔らかな肌へ導きます。同時に肌のキメも整えます。
            </>
          },
          {
            icon: <SvgSetGraphA03 />,
            name: <>
              マンデル酸<sup>※3</sup>
            </>,
            text1: <>
              アーモンド由来の角質ケア成分で、じわじわと角質層へ浸透し、毛穴へアプローチします。
            </>
          },
        ],
        note: '※1 ライム果汁、オレンジ果汁、レモン果汁、サンザシエキス、ナツメ果実エキス、グレープフルーツ果実エキス、リンゴ果実エキス（すべて整肌成分） ※2 角質層まで　※3 整肌成分　※写真はイメージです',
        color: '#B7CEB4'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionPeelCare20: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p1-2.png',
        name: 'ピールケアセラム2.0',
        variations: [
          {
            label: '1.0',
            color: '#BBD1BE',
            link: skuToUrl(productSku.peelCare10.single),
          },
          {
            label: '2.0',
            color: '#95B8BB',
            link: skuToUrl(productSku.peelCare20.single),
            active: true
          },
          {
            label: '3.0',
            color: '#589DAA',
            link: skuToUrl(productSku.peelCare30.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Pセラム２０'
          },
          {
            label: '容量',
            value: '20mL'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY1 <br />
              2日以上あけて週に2回〜3回（1日1回が上限／目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、グリセリン、ペンチレングリコール、グリコール酸、乳酸、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、マンデル酸、アラントイン、グリチルリチン酸２Ｋ、水溶性コラーゲン、イタドリ根エキス、オウゴン根エキス、カミツレ花エキス、カンゾウ根エキス、ツボクサエキス、チャ葉エキス、ローズマリー葉エキス、コンフリー葉エキス、ＰＥＧ－２０ソルビタンココエート、フィトステロールズ、ＢＧ、水添レシチン、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: '毛穴',
            color: '#95B8BB'
          },
          {
            label: 'ゴワつき',
            color: '#95B8BB'
          },
          {
            label: <>くすみ<sup>※</sup></>,
            color: '#95B8BB'
          }
        ],
        detail: <>
          角質ケアができる導入美容液。<br />
          グレード1.0は、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方向けの成分を厳選配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #95B8BB 20%, transparent)',
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'PeelCare Serum Ingredients',
        text2: '毛穴が目立つ肌に手応えのある角層ケア',
        text3: <>
          毛穴が目立つ肌に、手応えを重視した角質ケア。グリコール酸<sup>※1</sup>が配合され、ピリピリ感の手応えがあります。ピリつきが気になる場合は、洗い流しも可能。顔全体の、ザラつきやゴワつきが気になる方におすすめです。
        </>,
        graph: 'p1-2.mp4',
        items: [
          {
            icon: <SvgSetGraphA04 />,
            name: <>
              グリコール酸<sup>※2</sup>
            </>,
            text1: <>
              分子量が小さく、角質層のすみずまで浸透するので、角質層全体にしっかりアプローチします。
            </>
          },
          {
            icon: <SvgSetGraphA02 />,
            name: <>
              乳酸<sup>※1</sup>
            </>,
            text1: <>
              やさしく肌表面の角質をケアし、柔らかな肌へ導きます。同時に肌のキメも整えます。
            </>
          },
          {
            icon: <SvgSetGraphA03 />,
            name: <>
              マンデル酸<sup>※1</sup>
            </>,
            text1: <>
              アーモンド由来の角質ケア成分で、じわじわと角質層へ浸透し、毛穴へアプローチします。
            </>
          },
        ],
        note: '※1 角質層まで　※2 整肌成分　※写真はイメージです',
        color: '#95B8BB'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionPeelCare30: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p1-3.png',
        name: 'ピールケアセラム3.0',
        variations: [
          {
            label: '1.0',
            color: '#BBD1BE',
            link: skuToUrl(productSku.peelCare10.single),
          },
          {
            label: '2.0',
            color: '#95B8BB',
            link: skuToUrl(productSku.peelCare20.single),
          },
          {
            label: '3.0',
            color: '#589DAA',
            link: skuToUrl(productSku.peelCare30.single),
            active: true
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Pセラム３０'
          },
          {
            label: '容量',
            value: '20mL'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY1<br />
              2日以上あけて週に2回〜3回（1日1回が上限／目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、グリセリン、グリコール酸、ペンチレングリコール、マンデル酸、乳酸、アセチルヒアルロン酸Ｎａ、ヒアルロン酸Ｎａ、ヒアルロン酸クロスポリマー－２－Ｎａ、加水分解ヒアルロン酸Ｎａ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、アラントイン、グリチルリチン酸２Ｋ、イタドリ根エキス、オウゴン根エキス、カミツレ花エキス、カンゾウ根エキス、ツボクサエキス、チャ葉エキス、ローズマリー葉エキス、スイゼンジノリ多糖体、コンフリー葉エキス、カルボキシメチル－β－グルカンＮａ、ＰＥＧ－２０ソルビタンココエート、クエン酸、フィトステロールズ、キサンタンガム、ＢＧ、水添レシチン、エチルヘキシルグリセリン、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: '毛穴',
            color: '#589DAA'
          },
          {
            label: 'ゴワつき',
            color: '#589DAA'
          },
          {
            label: <>くすみ<sup>※</sup></>,
            color: '#589DAA'
          }
        ],
        detail: <>
          角質ケアができる導入美容液。<br />
          グレード1.0は、ピリピリ感が苦手な方や、優しく徐々に角質を整えたい方向けの成分を厳選配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #589DAA 20%, transparent)',
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'PeelCare Serum Ingredients',
        text2: 'ピーリング上級者向けの洗い流すピーリングケア',
        text3: 'ピーリングに使い慣れている、上級者向けの角質ケア。強いピリピリ感があり、5分程度置いてからぬるま湯で洗い流します。バランスの乱れによる過剰な皮脂分泌、ニキビのあとの凸凹といった深刻な肌悩みを抱える方におすすめです。',
        graph: 'p1-2.mp4',
        items: [
          {
            icon: <SvgSetGraphA04 />,
            name: <>
              グリコール酸<sup>※2</sup>
            </>,
            text1: <>
              分子量が小さく、角質層のすみずまで浸透するので、角質層全体にしっかりアプローチします。
            </>
          },
          {
            icon: <SvgSetGraphA02 />,
            name: <>
              乳酸<sup>※1</sup>
            </>,
            text1: <>
              やさしく肌表面の角質をケアし、柔らかな肌へ導きます。同時に肌のキメも整えます。
            </>
          },
          {
            icon: <SvgSetGraphA03 />,
            name: <>
              マンデル酸<sup>※1</sup>
            </>,
            text1: <>
              アーモンド由来の角質ケア成分で、じわじわと角質層へ浸透し、毛穴へアプローチします。
            </>
          },
        ],
        note: '※1 整肌成分　※写真はイメージです',
        color: '#589DAA'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionRetinoDermo01: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p2-1.png',
        name: 'レチノダーマクリーム0.1',
        variations: [
          {
            label: '0.1',
            color: '#EFBAB4',
            link: skuToUrl(productSku.retinoDermo01.single),
            active: true
          },
          {
            label: '0.2',
            color: '#EE958F',
            link: skuToUrl(productSku.retinoDermo02.single),
          },
          {
            label: '0.4',
            color: '#E98760',
            link: skuToUrl(productSku.retinoDermo04.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Aクリーム０１'
          },
          {
            label: '容量',
            value: '20g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 / 最初は3日おきから始める（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、ＢＧ、スクワラン、グリセリン、ペンチレングリコール、ホホバ種子油、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、アセチルヒアルロン酸Ｎａ、バクチオール、パルミチン酸レチノール、レチノイン酸トコフェリル、レチノール、ヒアルロン酸Ｎａ、ヒアルロン酸クロスポリマー－２－Ｎａ、加水分解ヒアルロン酸Ｎａ、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、フェルラ酸エチル、ホップエキス、キハダ樹皮エキス、フィトステロールズ、ココアンホジ酢酸２Ｎａ、ヒマワリ種子油、プロパンジオール、キサンタンガム、トリ（カプリル酸／カプリン酸）グリセリル、レシチン、水添レシチン、カルナウバロウ、コーン油、トコフェロール、ＢＨＴ、ポリソルベート２０、エチルヘキシルグリセリン、ニオイテンジクアオイ油、パルマローザ油、ベルガモット果実油、ＥＤＴＡ－２Ｎａ、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: 'ハリ',
            color: '#EFBAB4'
          },
          {
            label: 'ツヤのケア',
            color: '#EFBAB4'
          }
        ],
        detail: <>
          ピュアレチノール<sup>※</sup>を配合した美容クリーム。<br />
          グレード0.1は、レチノール初心者さん向けに、肌への負担を考えた成分を厳選しています。
        </>,
        detailBackground: 'color-mix(in lch, #EFBAB4 20%, transparent)',
        detailNote: '※レチノール(整肌成分)'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'RetinoDerm™ Ingredients',
        text2: <>ピュアレチノール<sup>※1</sup>が角質層のすみずみに浸透します</>,
        text3: <>角質層のすみずみにレチノールを届けるケア。植物由来のバクチオール<sup>※1</sup>も配合されたレチノール<sup>※1</sup>初心者向けのアイテムです。ハリやツヤの不足が気になり、毎日のお手入れが物足りなく感じている方におすすめです。</>,
        graph: 'p2-1.mp4',
        items: [
          {
            icon: <SvgSetGraphB01 />,
            name: <>
              バクチオール<sup>※1</sup>
            </>,
            text1: <>
              敏感肌の方でもご使用いただけるレチノールと同じような効果が期待される植物由来のレチノール
            </>
          },
          {
            icon: <SvgSetGraphB02 />,
            name: <>
              パルミチン酸レチノール<sup>※1</sup>
            </>,
            text1: <>
              安定性が特徴の成分。時間をかけてじっくり角質層へ浸透していく成分です。
            </>
          },
          {
            icon: <SvgSetGraphB03 />,
            name: <>
              レチノイン酸トコフェリル<sup>※1</sup>
            </>,
            text1: <>
              レチノールよりも活性型のレチノイン酸とビタミンEが結合した誘導体の成分。
            </>
          },
          {
            icon: <SvgSetGraphB04 />,
            name: <>
              レチノール<sup>※1</sup>
            </>,
            text1: <>
              すばやく角質層全体になじみ、ハリやツヤを与える美容成分。肌本来の強さをサポートします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#EFBAB4'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionRetinoDermo01Pouch: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'sk3.png',
        name: 'レチノダーマクリーム0.1',
        variations: [
          {
            label: '0.1',
            color: '#EFBAB4',
            link: skuToUrl(productSku.retinoDermo01.single),
            active: true
          },
          {
            label: '0.2',
            color: '#EE958F',
            link: skuToUrl(productSku.retinoDermo02.single),
          },
          {
            label: '0.4',
            color: '#E98760',
            link: skuToUrl(productSku.retinoDermo04.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'スキンリメド　レチノダーマクリーム０１　サシェ'
          },
          {
            label: '容量',
            value: '0.8g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 / 最初は3日おきから始める（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、ＢＧ、スクワラン、グリセリン、ペンチレングリコール、ホホバ種子油、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、アセチルヒアルロン酸Ｎａ、バクチオール、パルミチン酸レチノール、レチノイン酸トコフェリル、レチノール、ヒアルロン酸Ｎａ、ヒアルロン酸クロスポリマー－２－Ｎａ、加水分解ヒアルロン酸Ｎａ、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、フェルラ酸エチル、ホップエキス、キハダ樹皮エキス、フィトステロールズ、ココアンホジ酢酸２Ｎａ、ヒマワリ種子油、プロパンジオール、キサンタンガム、トリ（カプリル酸／カプリン酸）グリセリル、レシチン、水添レシチン、カルナウバロウ、コーン油、トコフェロール、ＢＨＴ、ポリソルベート２０、エチルヘキシルグリセリン、ニオイテンジクアオイ油、パルマローザ油、ベルガモット果実油、ＥＤＴＡ－２Ｎａ、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: 'ハリ',
            color: '#EFBAB4'
          },
          {
            label: 'ツヤのケア',
            color: '#EFBAB4'
          }
        ],
        detail: <>
          ピュアレチノール<sup>※</sup>を配合した美容クリーム。<br />
          グレード0.1は、レチノール初心者さん向けに、肌への負担を考えた成分を厳選しています。
        </>,
        detailBackground: 'color-mix(in lch, #EFBAB4 20%, transparent)',
        detailNote: '※レチノール(整肌成分)'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'RetinoDerm™ Ingredients',
        text2: <>ピュアレチノール<sup>※1</sup>が角質層のすみずみに浸透します</>,
        text3: <>角質層のすみずみにレチノールを届けるケア。植物由来のバクチオール<sup>※1</sup>も配合されたレチノール<sup>※1</sup>初心者向けのアイテムです。ハリやツヤの不足が気になり、毎日のお手入れが物足りなく感じている方におすすめです。</>,
        graph: 'p2-1.mp4',
        items: [
          {
            icon: <SvgSetGraphB01 />,
            name: <>
              バクチオール<sup>※1</sup>
            </>,
            text1: <>
              敏感肌の方でもご使用いただけるレチノールと同じような効果が期待される植物由来のレチノール
            </>
          },
          {
            icon: <SvgSetGraphB02 />,
            name: <>
              パルミチン酸レチノール<sup>※1</sup>
            </>,
            text1: <>
              安定性が特徴の成分。時間をかけてじっくり角質層へ浸透していく成分です。
            </>
          },
          {
            icon: <SvgSetGraphB03 />,
            name: <>
              レチノイン酸トコフェリル<sup>※1</sup>
            </>,
            text1: <>
              レチノールよりも活性型のレチノイン酸とビタミンEが結合した誘導体の成分。
            </>
          },
          {
            icon: <SvgSetGraphB04 />,
            name: <>
              レチノール<sup>※1</sup>
            </>,
            text1: <>
              すばやく角質層全体になじみ、ハリやツヤを与える美容成分。肌本来の強さをサポートします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#EFBAB4'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionRetinoDermo02: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p2-2.png',
        name: 'レチノダーマクリーム0.2',
        variations: [
          {
            label: '0.1',
            color: '#EFBAB4',
            link: skuToUrl(productSku.retinoDermo01.single),
          },
          {
            label: '0.2',
            color: '#EE958F',
            link: skuToUrl(productSku.retinoDermo02.single),
            active: true
          },
          {
            label: '0.4',
            color: '#E98760',
            link: skuToUrl(productSku.retinoDermo04.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Aクリーム０２'
          },
          {
            label: '容量',
            value: '20g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 / 最初は3日おきから始める（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、ＢＧ、スクワラン、グリセリン、ペンチレングリコール、ホホバ種子油、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、アセチルヒアルロン酸Ｎａ、レチノイルヒアルロン酸Ｎａ、レチノール、パルミチン酸レチノール、レチノイン酸トコフェリル、ヒアルロン酸Ｎａ、ヒアルロン酸クロスポリマー－２－Ｎａ、加水分解ヒアルロン酸Ｎａ、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、フェルラ酸エチル、ホップエキス、キハダ樹皮エキス、フィトステロールズ、ココアンホジ酢酸２Ｎａ、ヒマワリ種子油、プロパンジオール、キサンタンガム、トリ（カプリル酸／カプリン酸）グリセリル、レシチン、水添レシチン、カルナウバロウ、コーン油、トコフェロール、ＢＨＴ、ポリソルベート２０、エチルヘキシルグリセリン、ニオイテンジクアオイ油、パルマローザ油、ベルガモット果実油、ＥＤＴＡ－２Ｎａ、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: 'ハリ',
            color: '#EE958F'
          },
          {
            label: 'ツヤのケア',
            color: '#EE958F'
          }
        ],
        detail: <>
          ピュアレチノール<sup>※</sup>を配合した美容クリーム。グレード0.2は、肌のゴワつきや毛穴、乾燥によるくすみが気になる人に役立つ成分を厳選しています。すでにレチノールを日々お使いの方などレチノール中級者の方におすすめです。
        </>,
        detailBackground: 'color-mix(in lch, #EEE958F 15%, transparent)',
        detailNote: '※レチノール(整肌成分)'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'RetinoDerm™ Ingredients',
        text2: <>攻めと守りのバランスを見極めた、レチノール<sup>※1</sup>のアプローチ</>,
        text3: <>3日に1回の使用から始める、レチノール<sup>※1</sup>中級者向けのアイテム。独自のレチノブレンドで、攻めと守りのバランスを見極めたお手入れに取り組めます。乾燥による肌のゴワ付きやキメの乱れが気になる方におすすめです。</>,
        graph: 'p2-2.mp4',
        items: [
          {
            icon: <SvgSetGraphB02 />,
            name: <>
              パルミチン酸レチノール<sup>※3</sup>
            </>,
            text1: <>
              安定性が特徴の成分。時間をかけてじっくり角質層へ浸透していく成分です。
            </>
          },
          {
            icon: <SvgSetGraphB05 />,
            name: <>
              レチノイルヒアルロン酸Na<sup>※1</sup>
            </>,
            text1: <>
              レチノールをヒアルロン酸Naでカプセル化した保湿型レチノールです。
            </>,
            text2: <>
              RetinoDerm0.2以上での配合
            </>
          },
          {
            icon: <SvgSetGraphB03 />,
            name: <>
              レチノイン酸トコフェリル<sup>※1</sup>
            </>,
            text1: <>
              レチノールよりも活性型のレチノイン酸とビタミンEが結合した誘導体の成分。
            </>
          },
          {
            icon: <SvgSetGraphB04 />,
            name: <>
              レチノール<sup>※</sup>
            </>,
            text1: <>
              すばやく角質層全体になじみ、ハリやツヤを与える美容成分。肌本来の強さをサポートします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#EE958F'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionRetinoDermo04: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p2-3.png',
        name: 'レチノダーマクリーム0.4',
        variations: [
          {
            label: '0.1',
            color: '#EFBAB4',
            link: skuToUrl(productSku.retinoDermo01.single),
          },
          {
            label: '0.2',
            color: '#EE958F',
            link: skuToUrl(productSku.retinoDermo02.single),
          },
          {
            label: '0.4',
            color: '#E98760',
            link: skuToUrl(productSku.retinoDermo04.single),
            active: true
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Aクリーム０４'
          },
          {
            label: '容量',
            value: '20g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷暗所'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 / 最初は3日おきから始める（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、ＢＧ、スクワラン、グリセリン、ペンチレングリコール、ホホバ種子油、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、アセチルヒアルロン酸Ｎａ、レチノール、レチノイン酸トコフェリル、レチノイルヒアルロン酸Ｎａ、パルミチン酸レチノール、ヒアルロン酸Ｎａ、ヒアルロン酸クロスポリマー－２－Ｎａ、加水分解ヒアルロン酸Ｎａ、グリチルリチン酸２Ｋ、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、フェルラ酸エチル、ホップエキス、キハダ樹皮エキス、フィトステロールズ、ココアンホジ酢酸２Ｎａ、ヒマワリ種子油、プロパンジオール、キサンタンガム、トリ（カプリル酸／カプリン酸）グリセリル、レシチン、水添レシチン、カルナウバロウ、コーン油、トコフェロール、ＢＨＴ、ポリソルベート２０、エチルヘキシルグリセリン、ニオイテンジクアオイ油、パルマローザ油、ベルガモット果実油、ＥＤＴＡ－２Ｎａ、フェノキシエタノール'
          },
        ],
        tags: [
          {
            label: 'ハリ',
            color: '#E98760'
          },
          {
            label: 'ツヤのケア',
            color: '#E98760'
          }
        ],
        detail: <>
          ピュアレチノール<sup>※</sup>を配合した美容クリーム。<br />
          グレード0.4は、レチノールに慣れて肌への耐性がある方向けに、攻めたアプローチを叶える成分を厳選しています。
        </>,
        detailBackground: 'color-mix(in lch, #E98760 15%, transparent)',
        detailNote: '※レチノール(整肌成分)'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'RetinoDerm™ Ingredients',
        text2: <>ピュアレチノール<sup>※1</sup>を味方につける上級者向けのケア</>,
        text3: <>攻めのレチノール<sup>※1</sup>ケアに取り組める上級者向けのアイテム。角質層全体にあますことなくピュアレチノール<sup>※1</sup>が浸透し、肌にハリやツヤを与えます。年齢を感じる肌悩みを抱える方におすすめです。</>,
        graph: 'p2-3.mp4',
        items: [
          {
            icon: <SvgSetGraphB02 />,
            name: <>
              パルミチン酸レチノール<sup>※1</sup>
            </>,
            text1: <>
              安定性が特徴の成分。時間をかけてじっくり角質層へ浸透していく成分です。
            </>
          },
          {
            icon: <SvgSetGraphB05 />,
            name: <>
              レチノイルヒアルロン酸Na<sup>※1</sup>
            </>,
            text1: <>
              レチノールをヒアルロン酸Naでカプセル化した保湿型レチノールです。
            </>,
            text2: <>
              RetinoDerm0.2以上での配合
            </>
          },
          {
            icon: <SvgSetGraphB03 />,
            name: <>
              レチノイン酸トコフェリル<sup>※1</sup>
            </>,
            text1: <>
              レチノールよりも活性型のレチノイン酸とビタミンEが結合した誘導体の成分。
            </>
          },
          {
            icon: <SvgSetGraphB04 />,
            name: <>
              レチノール<sup>※</sup>
            </>,
            text1: <>
              すばやく角質層全体になじみ、ハリやツヤを与える美容成分。肌本来の強さをサポートします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#E98760'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionHydroLight25: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p3-1.png',
        name: 'ハイドロライトクリーム2.5',
        variations: [
          {
            label: '2.5',
            color: '#C6B7D8',
            link: skuToUrl(productSku.hydroLight25.single),
            active: true
          },
          {
            label: '4.0',
            color: '#A98EBB',
            link: skuToUrl(productSku.hydroLight40.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Hクリーム２５'
          },
          {
            label: '容量',
            value: '15g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '要冷蔵'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 （目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、スクワラン、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、ハイドロキノン、１，２－ヘキサンジオール、ステアリン酸グリセリル、アラントイン、ツボクサエキス、マデカッソシド、グリチルリチン酸２Ｋ、乳酸、乳酸Ｎａ、コンフリー葉エキス、アシアチコシド、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、パルミチン酸レチノール、レチノール、トリ（カプリル酸／カプリン酸）グリセリル、カルボキシメチル－β－グルカンＮａ、フィトステロールズ、ＢＧ、レシチン、水添レシチン、トコフェロール、ポリソルベート６０、ピロ亜硫酸Ｎａ、エチドロン酸、ＢＨＴ'
          },
        ],
        tags: [
          {
            label: <>
              スポットケア・くすみ<sup>※1</sup>ケア
            </>,
            color: '#C6B7D8'
          }
        ],
        detail: <>
          ハイドロキノン<sup>※2</sup>を配合した美容クリーム。グレード＝2.5は、全顔のくすみ<sup>※1</sup>ケア向けの成分を配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #C6B7D8 15%, transparent)',
        detailNote: '※1 乾燥による　※2 ハイドロキノン（整肌成分）'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'HydroLight™ Ingredients',
        text2: <>肌への刺激を考えながらハイドロキノン<sup>※1</sup>を角質層へ</>,
        text3: <>キメの乱れや乾燥によるくすみ、顔全体のどんより感が気になる方におすすめのハイドロライトクリーム。成分の強さと肌への負担を意識しながら、ハイドロキノン<sup>※1</sup>を角質層のすみずみに届けます。</>,
        graph: 'p3-1.mp4',
        items: [
          {
            icon: <SvgSetGraphD01 />,
            name: <>
              アラントイン<sup>※1</sup>
            </>,
            text1: <>
              ゆらぎがちな肌にうるおいを与え、キメの整ったなめらかな肌へ導きます。
            </>
          },
          {
            icon: <SvgSetGraphD02 />,
            name: <>
              ツボクサエキス<sup>※1</sup>
            </>,
            text1: <>
              韓国コスメで注目された別名「CICA」の、植物由来エキス。角層レベルでハリやツヤを与えます。
            </>
          },
          {
            icon: <SvgSetGraphD03 />,
            name: <>
              マデカッソシド<sup>※1</sup>
            </>,
            text1: <>
              CICAから潤い成分を高純度抽出したエキス。保湿ケアに優れ、輝きを放つ健やかな肌にアプローチ。
            </>
          },
          {
            icon: <SvgSetGraphD04 />,
            name: <>
              グリチルリチン酸2K<sup>※1</sup>
            </>,
            text1: <>
              乾燥を繰り返し、うるおいバリアが弱った肌へ、濃密なうるおいを角質層へ満たします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#C6B7D8'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionHydroLight40: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p3-2.png',
        name: 'ハイドロライトクリーム4.0',
        variations: [
          {
            label: '2.5',
            color: '#C6B7D8',
            link: skuToUrl(productSku.hydroLight25.single),
          },
          {
            label: '4.0',
            color: '#A98EBB',
            link: skuToUrl(productSku.hydroLight40.single),
            active: true
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Sリメド Hクリーム４０'
          },
          {
            label: '容量',
            value: '15g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '冷蔵保存'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY2（スキンサイクルメソッドの2日目）<br />
              1日夜のみ1回 （目安）<br />
              スポットケアなど部分的に使用推奨
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: '水、スクワラン、ハイドロキノン、（アクリル酸ヒドロキシエチル／アクリロイルジメチルタウリンＮａ）コポリマー、１，２－ヘキサンジオール、ステアリン酸グリセリル、アラントイン、ツボクサエキス、マデカッソシド、グリチルリチン酸２Ｋ、乳酸、乳酸Ｎａ、コンフリー葉エキス、アシアチコシド、セラミドＮＧ、セラミドＡＰ、セラミドＡＧ、セラミドＮＰ、セラミドＥＯＰ、パルミチン酸レチノール、レチノール、トリ（カプリル酸／カプリン酸）グリセリル、カルボキシメチル－β－グルカンＮａ、フィトステロールズ、ＢＧ、レシチン、水添レシチン、トコフェロール、ポリソルベート６０、ピロ亜硫酸Ｎａ、エチドロン酸、ＢＨＴ'
          },
        ],
        tags: [
          {
            label: <>
              スポットケア・くすみ<sup>※1</sup>ケア
            </>,
            color: '#A98EBB'
          }
        ],
        detail: <>
          ハイドロキノン<sup>※2</sup>を配合した美容クリーム。グレード4.0は、気になるスポットケア向けの成分を配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #A98EBB 15%, transparent)',
        detailNote: '※1 乾燥による　※2 ハイドロキノン（整肌成分）'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'HydroLight™ Ingredients',
        text2: <>年齢を感じる肌に、ハイドロキノン<sup>※1</sup>の濃いスポットケア</>,
        text3: <>深刻な肌悩みにアプローチする、ハイドロキノン※上級者向けのアイテム。濃密なハイドロキノン<sup>※1</sup>のお手入れに取り組めます。ピンポイントの集中ケアや、濃いスポットケアにおすすめです。</>,
        graph: 'p3-1.mp4',
        items: [
          {
            icon: <SvgSetGraphD01 />,
            name: <>
              アラントイン<sup>※1</sup>
            </>,
            text1: <>
              ゆらぎがちな肌にうるおいを与え、キメの整ったなめらかな肌へ導きます。
            </>
          },
          {
            icon: <SvgSetGraphD02 />,
            name: <>
              ツボクサエキス<sup>※1</sup>
            </>,
            text1: <>
              韓国コスメで注目された別名「CICA」の、植物由来エキス。角層レベルでハリやツヤを与えます。
            </>
          },
          {
            icon: <SvgSetGraphD03 />,
            name: <>
              マデカッソシド<sup>※1</sup>
            </>,
            text1: <>
              CICAから潤い成分を高純度抽出したエキス。保湿ケアに優れ、輝きを放つ健やかな肌にアプローチ。
            </>
          },
          {
            icon: <SvgSetGraphD04 />,
            name: <>
              グリチルリチン酸2K<sup>※1</sup>
            </>,
            text1: <>
              乾燥を繰り返し、うるおいバリアが弱った肌へ、濃密なうるおいを角質層へ満たします。
            </>
          }
        ],
        note: '※1 すべて整肌成分　※ 写真はイメージです',
        color: '#A98EBB'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionNiachinaGlow: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p4-1.png',
        name: <>薬用ナイアシナグロージェル<BoxText>医薬部外品</BoxText></>,
        variations: [],
        info1: [
          {
            label: '製販名',
            value: 'ＳＲ　薬用Nジェル'
          },
          {
            label: '容量',
            value: '50g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '直射日光のあたる場所、極端に低温または高温、多湿の場所を避けて保管'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY3/4（スキンサイクルメソッド中毎日使用可能）<br />
              朝・夜　毎日使用（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              ナイアシンアミド＊、グリチルリチン酸ジカリウム＊、濃グリセリン、２－エチルヘキサン酸セチル、１，３－ブチレングリコール、ポリグリセリン、リンゴ酸ジイソステアリル、１，２－ペンタンジオール、水素添加大豆リン脂質、ヒアルロン酸ナトリウム（２）、ヒアルロン酸ヒドロキシプロピルトリモニウム、加水分解ヒアルロン酸、レチノール油液（ビタミンＡ　１６６，６６７ＩＵ／ｇ）、Ｄ－パントテニルアルコール、アラントイン、ヒドロキシステアリルフィトスフィンゴシン、Ｎ－ステアロイルジヒドロスフィンゴシン、Ｎ－ステアロイルフィトスフィンゴシン、ステアロイルオキシへプタコサノイルフィトスフィンゴシン、水溶性コラーゲン液（３）、シュガースクワラン、アマチャヅルエキス、セージエキス、ドクダミエキス、水酸化ナトリウム、ジペンタエリトリット脂肪酸エステル（１）、Ｎ－ラウロイル－Ｌ－グルタミン酸ジ（フィトステリル・２－オクチルドデシル）、ジリノール酸ジ（フィトステリル／イソステアリル／セチル／ステアリル／ベヘニル）、マカデミアナッツ油脂肪酸フィトステリル、１，２－ヘキサンジオール・１，２－オクタンジオール混合物、ジエチレントリアミン五酢酸五ナトリウム液、カルボキシビニルポリマー、フィトステロール、天然ビタミンＥ、クエン酸、クエン酸ナトリウム、フェノキシエタノール<br />
              ＊は「有効成分」、無表示は「その他の成分」
            </>
          },
        ],
        tags: [
          {
            label: '高保湿',
            color: '#D9AFCB'
          },
          {
            label: '潤いバリアケア',
            color: '#D9AFCB'
          },
          {
            label: 'ツヤ',
            color: '#D9AFCB'
          }
        ],
        detail: <>
          美白<sup>※1</sup>、シワ改善効果を持つナイアシンアミド<sup>※2</sup>と肌荒れを防ぐグリチルリチン酸ジカリウム<sup>※2</sup>を配合した保湿ジェル。
          集中ケア後のおやすみ期間中に肌を労わるケアで、潤いバリアをサポートします。
        </>,
        detailBackground: 'color-mix(in lch, #D9AFCB 20%, transparent)',
        detailNote: '※1 メラニンの生成を抑え、シミ・そばかすを防ぐ　※2 有効成分'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'NiacinaGlow™ Ingredients',
        text2: '角質層全体にうるおいを与えキメの整った素肌へ導きます',
        text3: '角質層全体にうるおいを与え、肌本来が持つ潤いバリアをサポート。おやすみ期間中の肌を労わりながら肌環境を整えて、肌悩みを跳ね返すようないきいきと健やかな素肌へ導きます。',
        graph: 'p4-1.mp4',
        items: [
          {
            icon: <SvgSetGraphC01 />,
            name: <>
              ナイアシンアミド<sup>※1</sup>
            </>,
            text1: <>
              ハリのあるツヤ肌へ導きます。​また、年齢とともに気になるキメの乱れなどにもアプローチします。​
            </>
          },
          {
            icon: <SvgSetGraphC02 />,
            name: <>
              3種のリカデリバリー成分<sup>※2</sup>
            </>,
            text1: <>
              高濃度の集中ケア後、おやすみ期間中の肌のゆらぎを防ぐために。肌を労わる成分を厳選しました。
            </>
          },
        ],
        note: '※1 整肌成分　※2 パンテノール、アラントイン、グリチルリチン酸２Ｋ（すべて整肌成分） ※ 写真はイメージです',
        color: '#D9AFCB'
      }} />
  </Detail2Container>
</SectionOuter>

export const SetProductsSectionNiachinaGlowMini: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'sk4.png',
        name: <>薬用ナイアシナグロージェル<BoxText>医薬部外品</BoxText></>,
        variations: [],
        info1: [
          {
            label: '製販名',
            value: 'スキンリメド　薬用ナイアシナグロージェル　トライアルチューブ'
          },
          {
            label: '容量',
            value: '8g'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: '直射日光のあたる場所、極端に低温または高温、多湿の場所を避けて保管'
          },
          {
            label: '使うタイミング',
            value: <>
              DAY3/4（スキンサイクルメソッド中毎日使用可能）<br />
              朝・夜　毎日使用（目安）
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              ナイアシンアミド＊、グリチルリチン酸ジカリウム＊、濃グリセリン、２－エチルヘキサン酸セチル、１，３－ブチレングリコール、ポリグリセリン、リンゴ酸ジイソステアリル、１，２－ペンタンジオール、水素添加大豆リン脂質、ヒアルロン酸ナトリウム（２）、ヒアルロン酸ヒドロキシプロピルトリモニウム、加水分解ヒアルロン酸、レチノール油液（ビタミンＡ　１６６，６６７ＩＵ／ｇ）、Ｄ－パントテニルアルコール、アラントイン、ヒドロキシステアリルフィトスフィンゴシン、Ｎ－ステアロイルジヒドロスフィンゴシン、Ｎ－ステアロイルフィトスフィンゴシン、ステアロイルオキシへプタコサノイルフィトスフィンゴシン、水溶性コラーゲン液（３）、シュガースクワラン、アマチャヅルエキス、セージエキス、ドクダミエキス、水酸化ナトリウム、ジペンタエリトリット脂肪酸エステル（１）、Ｎ－ラウロイル－Ｌ－グルタミン酸ジ（フィトステリル・２－オクチルドデシル）、ジリノール酸ジ（フィトステリル／イソステアリル／セチル／ステアリル／ベヘニル）、マカデミアナッツ油脂肪酸フィトステリル、１，２－ヘキサンジオール・１，２－オクタンジオール混合物、ジエチレントリアミン五酢酸五ナトリウム液、カルボキシビニルポリマー、フィトステロール、天然ビタミンＥ、クエン酸、クエン酸ナトリウム、フェノキシエタノール<br />
              ＊は「有効成分」、無表示は「その他の成分」
            </>
          },
        ],
        tags: [
          {
            label: '高保湿',
            color: '#D9AFCB'
          },
          {
            label: '潤いバリアケア',
            color: '#D9AFCB'
          },
          {
            label: 'ツヤ',
            color: '#D9AFCB'
          }
        ],
        detail: <>
          美白<sup>※1</sup>、シワ改善効果を持つナイアシンアミド<sup>※2</sup>と肌荒れを防ぐグリチルリチン酸ジカリウム<sup>※2</sup>を配合した保湿ジェル。
          集中ケア後のおやすみ期間中に肌を労わるケアで、潤いバリアをサポートします。
        </>,
        detailBackground: 'color-mix(in lch, #D9AFCB 20%, transparent)',
        detailNote: '※1 メラニンの生成を抑え、シミ・そばかすを防ぐ　※2 有効成分'
      }} />
  </Detail1Container>
  <Detail2Container>
    <ProductDetail2
      data={{
        text1: 'NiacinaGlow™ Ingredients',
        text2: '角質層全体にうるおいを与えキメの整った素肌へ導きます',
        text3: '角質層全体にうるおいを与え、肌本来が持つ潤いバリアをサポート。おやすみ期間中の肌を労わりながら肌環境を整えて、肌悩みを跳ね返すようないきいきと健やかな素肌へ導きます。',
        graph: 'p4-1.mp4',
        items: [
          {
            icon: <SvgSetGraphC01 />,
            name: <>
              ナイアシンアミド<sup>※1</sup>
            </>,
            text1: <>
              ハリのあるツヤ肌へ導きます。​また、年齢とともに気になるキメの乱れなどにもアプローチします。​
            </>
          },
          {
            icon: <SvgSetGraphC02 />,
            name: <>
              3種のリカデリバリー成分<sup>※2</sup>
            </>,
            text1: <>
              高濃度の集中ケア後、おやすみ期間中の肌のゆらぎを防ぐために。肌を労わる成分を厳選しました。
            </>
          },
        ],
        note: '※1 整肌成分　※2 パンテノール、アラントイン、グリチルリチン酸２Ｋ（すべて整肌成分） ※ 写真はイメージです',
        color: '#D9AFCB'
      }} />
  </Detail2Container>
</SectionOuter>


export const SetProductsSectionCareBrightSerum50: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p6-3.png',
        name: <>薬用ケアブライトセラム5.0<BoxText>医薬部外品</BoxText></>,
        variations: [
          {
            label: '5.0',
            color: '#DDCB05',
            link: skuToUrl(productSku.careBrightSerum50.single),
            active: true
          },
          {
            label: '27.0',
            color: '#F19800',
            link: skuToUrl(productSku.shineSerum270.single),
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'アントワーヌ　美白美容液ａ　Ｎ'
          },
          {
            label: '容量',
            value: '10ml'
          }
        ],
        info2: [
          {
            label: '使うタイミング',
            value: <>
              化粧水を使用した後
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              Ｌ－アスコルビン酸　２－グルコシド＊、グリチルリチン酸ジカリウム＊、ユキノシタエキス、オウゴンエキス、カンゾウフラボノイド、タイソウエキス、プルーン酵素分解物、クワエキス、１，２－ペンタンジオール、１，３－ブチレングリコール、濃グリセリン、モノミリスチン酸デカグリセリル、メチルフェニルポリシロキサン、トリ２－エチルヘキサン酸グリセリル、クエン酸、クエン酸ナトリウム、水酸化カリウム、精製水、アクリル酸・メタクリル酸アルキル共重合体、キサンタンガム、ジエチレントリアミン五酢酸五ナトリウム液、フェノキシエタノール、香料<br />
              ＊は「有効成分」、無表示は「その他の成分」
            </>
          },
        ],
        tags: [
          {
            label: <>シミ<sup>※1</sup></>,
            color: '#DDCB05'
          },
          {
            label: <>くすみ<sup>※2</sup></>,
            color: '#DDCB05'
          }
        ],
        tagsNote: <>
          ※1 乾燥による毛穴の目立ち<br />
          ※2 乾燥による
        </>,
        detail: <>
          美白<sup>※1</sup>しながら、肌荒れも防ぎシミ<sup>※1</sup> ・毛穴<sup>※2</sup>悩みへ優しくアプローチするビタミンC誘導体<sup>※3</sup>美容液<br />
          薬用ケアブライトセラム5.0は、ピリピリ感が苦手な方や、優しくケアしたい方向けの成分を厳選配合しています。
        </>,
        detailBackground: 'color-mix(in lch, #DDCB05 20%, transparent)',
        detailNote: <>
          ※1 メラニンの生成を抑え、しみ、そばかすを防ぐ<br />
          ※2 乾燥による<br />
          ※3 Ｌ－アスコルビン酸　２－グルコシド（有効成分）​
        </>
      }} />
  </Detail1Container>
</SectionOuter>


export const SetProductsSectionShineSerum270: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p7-3.png',
        name: <>VCシャインセラム27.0<BoxText>化粧品</BoxText></>,
        variations: [
          {
            label: '5.0',
            color: '#DDCB05',
            link: skuToUrl(productSku.careBrightSerum50.single),
          },
          {
            label: '27.0',
            color: '#F19800',
            link: skuToUrl(productSku.shineSerum270.single),
            active: true
          }
        ],
        info1: [
          {
            label: '製販名',
            value: 'Ｓリメド　Ｃセラム２７'
          },
          {
            label: '容量',
            value: '10ml'
          },
          {
            label: '保管方法',
            value: '冷蔵保存'
          }
        ],
        info2: [
          {
            label: '使うタイミング',
            value: <>
              化粧水を使用した後
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              水、アスコルビン酸、エトキシジグリコール、グリセリン、３－グリセリルアスコルビン酸、イソペンチルジオール、ＢＧ、パルミチン酸エチルヘキシル、パルミチン酸アスコルビルリン酸３Ｎａ、アスコルビルメチルカルボニルペンタペプチド－７２－トリ－ｔ－ブチルトリプトファナミド、（アスコルビル／トコフェリル）リン酸Ｋ、グルタチオン、カフェイン、トコフェロール、チャ葉エキス、キウイエキス、パイナップル果実エキス、セイヨウハッカ葉エキス、レスベラトロール、パンテノール、アラントイン、ヒアルロン酸Ｎａ、加水分解ヒアルロン酸、アセチルヒアルロン酸Ｎａ、ヒアルロン酸ジメチルシラノール、ヒアルロン酸ヒドロキシプロピルトリモニウム、ＰＣＡ－Ｎａ、ＰＣＡ、乳酸Ｎａ、ヒスチジン、フェニルアラニン、プロリン、トレオニン、イソロイシン、バリン、セリン、アラニン、グリシン、アスパラギン酸、アルギニン、金、ペンチレングリコール、ソルビトール、プロパンジオール、カプリリルグリコール、１，２－ヘキサンジオール、ＥＤＴＡ－２Ｎａ、キサンタンガム、水添レシチン、フィトステロールズ、フェニルエチルレゾルシノール、シリカ、ＰＥＧ－８、ＰＰＧ－６デシルテトラデセス－３０、水酸化Ｎａ、フェノキシエタノール、香料
            </>
          },
        ],
        tags: [
          {
            label: 'キメ',
            color: '#F19800'
          },
          {
            label: 'ざらつき',
            color: '#F19800'
          },
          {
            label: <>毛穴<sup>※1</sup></>,
            color: '#F19800'
          },
          {
            label: <>くすみ<sup>※2</sup></>,
            color: '#F19800'
          }
        ],
        tagsNote: <>
          ※1 乾燥による毛穴の目立ち<br />
          ※2 乾燥による
        </>,
        detail: <>
          毛穴<sup>※1</sup>・くすみ<sup>※2</sup>・肌のキメ・ハリ​などの深刻な肌悩みへアプローチ​極限濃度を目指した​ビタミンC<sup>※3</sup>配合美容液​。高濃度ビタミンC<sup>※3</sup>がさまざまな肌悩みに多角的にアプローチします。
        </>,
        detailBackground: 'color-mix(in lch, #F19800 20%, transparent)',
        detailNote: <>
          ※1 乾燥による毛穴の目立ち<br />
          ※2 乾燥による<br />
          ※3 アスコルビン酸（整肌成分）​
        </>
      }} />
  </Detail1Container>
</SectionOuter>


export const SetProductsSectionDermaSerumUv: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p5-3.png',
        name: <>薬用ダーマセラムUV　ヘパリバリア<BoxText>医薬部外品</BoxText></>,
        variations: [],
        info1: [
          {
            label: '製販名',
            value: '保湿プロテクトHG21'
          },
          {
            label: '容量',
            value: '30g'
          }
        ],
        info2: [
          {
            label: '使うタイミング',
            value: <>
              普段の日焼け止め、化粧下地を使用していただいているタイミングでお使いください。
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              ヘパリン類似物質＊、グリチルリチン酸ジカリウム＊、精製水、パルミチン酸２－エチルヘキシル、１，３－ブチレングリコール、ツボクサエキス、ヒアルロン酸ナトリウム（２）、Ｎ－ステアロイルフィトスフィンゴシン、ヒドロキシステアリルフィトスフィンゴシン、３－Ｏ－エチルアスコルビン酸、ユキノシタエキス、２－メタクリロイルオキシエチルホスホリルコリン・メタクリル酸ブチル共重合体液、シロキクラゲ多糖体、濃グリセリン、１，２－ペンタンジオール、マカデミアナッツ油脂肪酸フィトステリル、メチルポリシロキサン、イソノナン酸イソノニル、デカメチルシクロペンタシロキサン、イソステアリン酸、セタノール、低粘度メチルハイドロジェンポリシロキサン、メチルシロキサン網状重合体、架橋型メチルポリシロキサン、架橋ポリスチレン、ポリヒドロキシステアリン酸、含水ケイ酸、カルボキシメチルセルロースナトリウム、疎水化ヒドロキシプロピルメチルセルロース、水酸化アルミニウム、低温焼成酸化亜鉛、微粒子酸化チタン、フェノキシエタノール<br />
              ＊は「有効成分」、無表示は「その他の成分」
            </>
          },
        ],
        tags: [
          {
            label: '紫外線をブロック',
            color: '#b1aead'
          },
          {
            label: '化粧下地',
            color: '#b1aead'
          }
        ],
        detail: <>
          紫外線をブロックしながら、肌荒れも防ぎ日中の潤いを守る日焼け止め美容液
        </>,
        detailBackground: 'color-mix(in lch, #b1aead 20%, transparent)',
        detailNote: ''
      }} />
  </Detail1Container>
</SectionOuter>

export const SetProductsSectionMicroBubble: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p8-3.png',
        name: <>H2 マイクロバブルパックP</>,
        variations: [],
        info1: [
          {
            label: '製販名',
            value: <>
              Ｓリメド　ＨパックＰ　Ａ<br />
              Ｓリメド　ＨパックＰ　Ｂ
            </>
          },
          {
            label: '容量',
            value: 'ジェル20g・パウダー1g ×4 （４回分）'
          }
        ],
        info2: [
          {
            label: '保管方法',
            value: <>
              <ul>
                <li>開封後はすぐに使用してください。混合後の保管はしないでください。</li>
                <li>スパチュラは清潔な状態で使用してください。</li>
                <li>乳幼児の手の届かないところに保管してください。</li>
                <li>直射日光の当たる場所、極端に高温・低温になる場所を避けて保管してください。</li>
              </ul>
            </>
          },
          {
            label: '使うタイミング',
            value: <>
              洗顔後の清潔な肌にご使用ください。週1回のスペシャルケアや、大切なご予定の前のご使用がおすすめです。
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: <>
              ヘパリン類似物質＊、グリチルリチン酸ジカリウム＊、精製水、パルミチン酸２－エチルヘキシル、１，３－ブチレングリコール、ツボクサエキス、ヒアルロン酸ナトリウム（２）、Ｎ－ステアロイルフィトスフィンゴシン、ヒドロキシステアリルフィトスフィンゴシン、３－Ｏ－エチルアスコルビン酸、ユキノシタエキス、２－メタクリロイルオキシエチルホスホリルコリン・メタクリル酸ブチル共重合体液、シロキクラゲ多糖体、濃グリセリン、１，２－ペンタンジオール、マカデミアナッツ油脂肪酸フィトステリル、メチルポリシロキサン、イソノナン酸イソノニル、デカメチルシクロペンタシロキサン、イソステアリン酸、セタノール、低粘度メチルハイドロジェンポリシロキサン、メチルシロキサン網状重合体、架橋型メチルポリシロキサン、架橋ポリスチレン、ポリヒドロキシステアリン酸、含水ケイ酸、カルボキシメチルセルロースナトリウム、疎水化ヒドロキシプロピルメチルセルロース、水酸化アルミニウム、低温焼成酸化亜鉛、微粒子酸化チタン、フェノキシエタノール<br />
              ＊は「有効成分」、無表示は「その他の成分」
            </>
          },
        ],
        tags: [
        ],
        detail: <>
          自宅で叶える本格肌管理。水素のマイクロバブルがPDRN<sup>※1</sup>の浸透<sup>※2</sup>をサポートし、潤いあふれる弾力と輝くツヤを引き出すマイクロバブルパックSKN REMED　H2マイクロバブルパックP
          <ol>
            <li>15分で水素のマイクロバブルが高濃度発生。自然界に存在する元素の中で最も小さい水素で肌の奥<sup>※2</sup>まで浸透<br />ジェルとパウダーを混ぜ合わせる2剤式バブルパック</li>
            <li>水分・ツヤ・ハリへしっかりアプローチする水光ケア サーモンDNA由来の【PDRN<sup>※1</sup>】を配合</li>
            <li>水素との相性を考えた【厳選3種のRetinol<sup>※3</sup>処方】</li>
            <li>ハリのある肌へ導く７種のペプチド【Peptide-Shot<sup>※4</sup>】を配合</li>
          </ol>
        </>,
        detailBackground: 'color-mix(in lch, #b1aead 20%, transparent)',
        detailNote: '※1 DNA-Na（整肌成分）※2 角質層まで　※3 レチノイン酸ヒドロキシピナコロン、レチノール、パルミチン酸レチノール（すべて整肌成分） ※4 アセチルヘキサペプチド－８、パルミトイルトリペプチド－５、トリフルオロアセチルトリペプチド－２、ヘキサカルボキシメチルジペプチド－１２、パルミトイルテトラペプチド－７、パルミトイルトリぺプチド－１、ジ酢酸ジペプチドジアミノブチロイルベンジルアミド、パルミトイルジペプチド－５ジアミノブチロイルヒドロキシトレオニン（すべて保湿成分）​'
      }} />
  </Detail1Container>
</SectionOuter>

export const SetProductsSectionHerbPeelCleansingGel: FunctionComponent = () => <SectionOuter>
  <Detail1Container>
    <ProductDetail1
      data={{
        image: 'p9-3.png',
        name: <>ハーブピールクレンジングジェル</>,
        variations: [],
        info1: [
          {
            label: '製販名',
            value: 'ＳＲ Ｈクレンジング'
          },
          {
            label: '容量',
            value: '100g'
          }
        ],
        info2: [
          {
            label: 'ご使用方法',
            value: <>
              手と肌が乾いた状態でお使いください。手のひらに適量をとり、顔全体にやさしくなじませ、水またはぬるま湯で洗い流してください。毛穴汚れが気になる部分は、目・口周りを避けて均一に塗布し約5分間パックした後、なじませながら洗い流してください。暖かい環境でジェルのかたさが柔らかくなり流れやすくなる場合は、手のひらでやさしく肌になじませながらご使用ください。
            </>
          },
          {
            label: '使うタイミング',
            value: <>
              朝洗顔のタイミング・夜メイクを落とすタイミング
            </>
          }
        ],
        info3: [
          {
            label: '全成分一覧',
            value: 'パルミチン酸エチルヘキシル、グリセリン、イソノナン酸イソノニル、水、トリ（カプリル酸／カプリン酸）グリセリル、水添ファルネセン、ラウリン酸メチルヘプチル、グリコシルトレハロース、ソルビトール、トリイソステアリン酸ＰＥＧ－２０グリセリル、シクロヘキサン−１，４−ジカルボン酸ビスエトキシジグリコール、加水分解水添デンプン、ＢＧ、アゼライン酸、アゼロイルジグリシンＫ、グリシルグリシン、リンゴ酸、グルコノラクトン、サリチル酸、結晶セルロース、エチルセルロース、パルミチン酸アスコルビルリン酸３Ｎａ、ナイアシンアミド、ヨモギ葉エキス、ドクダミエキス、セージ葉エキス、ローズマリー葉エキス、アーチチョーク葉エキス、ハマメリス葉エキス、チャ葉エキス、キハダ樹皮エキス、ポリクオタニウム－５１、パンテノール、テトラヘキシルデカン酸アスコルビル、パルミチン酸レチノール、トコフェロール、ビオチン、シアノコバラミン、オリゴペプチド－３４、カプロオイルテトラペプチド－３、トリペプチド－３、カカオエキス、（クロロフィリン／銅）複合体、酸化鉄、ピーナッツ油、マンニトール、水添レシチン、サーファクチンＮａ、クエン酸、デキストラン、ペンチレングリコール、ローズマリー葉油、ユーカリ葉油、レモングラス油'
          },
        ],
        tags: [
        ],
        detail: <>
          ハーブピール発想で毛穴汚れや角栓をほぐし、肌を整えながらクリアな肌<sup>※</sup>へ導くジェルクレンジング。<br />
          SKN REMED　ハーブピールクレンジングジェル
        </>,
        detailBackground: 'color-mix(in lch, #233C31 20%, transparent)',
        detailNote: '※ 汚れが落ち、キメが整った肌印象のこと'
      }} />
  </Detail1Container>
</SectionOuter>